import { Media, MediaType } from '@/types'

export const getDisplayImage = (images: Pick<Media, 'url' | 'type'>[]) => {
  return images.find((m) => m.type !== MediaType.UPLOAD)
}
